import { getAppropriateRiskLimiter } from './';

// Providing a cancer type will limit the impact to the appropriate range for that cancer type. Useful when displaying overall risk, as the limits chagne
export function formatRiskDecimal(impact: number | string | undefined, cancerType?: string): string {
  const limiter = getAppropriateRiskLimiter(cancerType);
  const limitedImpact = limiter(impact);

  if (Number(limitedImpact) < 0.1) return `0.1%`;
  if (typeof limitedImpact === 'number') return `${roundDecimal(limitedImpact)}%`;
  if (typeof limitedImpact === 'string') {
    if (!isNaN(Number(limitedImpact))) return `${roundDecimal(Number(limitedImpact))}%`;
    return limitedImpact;
  }
  return 'N/A';
}

const roundDecimal = (number: number) => (Math.round(number * 10) / 10).toFixed(1);
